<template>
  <v-row no-gutters>
    <v-col>
      <card-title-row translationPath="sidebar.importDxf.title" class="py-6" align-class="align-center">
      </card-title-row>
      <v-row no-gutters>
        <v-col>
          <dxf-layers-list-wrapper></dxf-layers-list-wrapper>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import DxfLayersListWrapper from '@/components/DxfLayersListWrapper';

export default {
  name: 'ImportDxf',
  components: {
    CardTitleRow,
    DxfLayersListWrapper,
  },
};
</script>

<style lang="scss" scoped></style>
